/** Contains the actual project with all information */
/** Uses the componsents passed in to populate this page to reduce routing to tons of pages */

import React from 'react';
import { useLocation } from 'react-router-dom';
import BattleShip from '../Content/UniversityProjects/BattleShip';
import SeaMonkey from '../Content/UniversityProjects/SeaMonkey';
import CryptoGraph from '../Content/UniversityProjects/CryptoGraph';
import PowerUsage from '../Content/UniversityProjects/PowerUsage';
import IceCreamBoy from '../Content/PersonalProjects/IceCreamBoy';
import FarmWitch from '../Content/PersonalProjects/FarmWitch';
import Catventure from '../Content/PersonalProjects/Catventure';
import SuperJunkPop from '../Content/PersonalProjects/SuperJunkPop';
import BushFireWatch from '../Content/PersonalProjects/BushFireWatch';
import MarsRover from '../Content/UniversityProjects/MarsRover';
import Similarity from '../Content/UniversityProjects/Similarity';
import TextEditor from '../Content/UniversityProjects/TextEditor';
import CovGuard from '../Content/UniversityProjects/CovGuard';
import EditorChrome from './EditorChrome';
import universityContent from '../Content/UniversityContent';
import personalContent from '../Content/PersonalContent';

const Project = (props) =>
{
    const UniProjectArr = [
        <SeaMonkey/>,
        <BattleShip/>,
        <CryptoGraph/>,
        <PowerUsage/>,
        <MarsRover/>,
        <Similarity/>,
        <TextEditor/>,
        <CovGuard/>
    ]

    const PersonalProjectArr = [
        <IceCreamBoy/>,
        <FarmWitch/>,
        <Catventure/>,
        <SuperJunkPop/>,
        <BushFireWatch/>
    ]

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const queryIndex = Number.parseInt(params.get('id'), 10);
    const queryType = params.get('type');
    let componentIndex = Number.isInteger(queryIndex) ? queryIndex : undefined;
    let projectType = queryType;
    let component;

    if (componentIndex === undefined && location.component !== undefined)
    {
        componentIndex = location.component[0];
        projectType = location.component[1];
    }

    component = projectType === 'uni' ? UniProjectArr[componentIndex] : PersonalProjectArr[componentIndex];
    const projectMeta = (projectType === 'uni' ? universityContent : personalContent)
        .find((project) => project.component === componentIndex);
    const backRoute = projectType === 'uni' ? '/University' : '/Personal';

    return (
        <main className="container portfolio-shell inner-shell">
            <EditorChrome active="/Archive" />
            <section className="inner-editor archive-project-page">
                <a className="back-link" href={backRoute}>Back to archive</a>
                {projectMeta && <p className="project-detail-year">{projectMeta.year} · Archived project</p>}
                <div className="project-content">
                    {component ||
                        <div className="empty-project">
                            <h1>Project not found</h1>
                            <p>This archive link is incomplete or no longer available.</p>
                            <a className="btn" href="/Archive">Return to project archive</a>
                        </div>
                    }
                </div>
            </section>
        </main>
    );
}

export default Project;
